module.exports = __webpack_public_path__ + "img/identidades-con-impacto.f5c65953.png";